import type { OptionValue } from 'ebs-design/dist/components/molecules/Select/interfaces';
import { Properties } from 'types';
import { dateFormat, today } from 'libs';

export const defaultFilters: Properties = {
  page: 1,
  per_page: 50,
};

export const defaultNonPagination: Properties = {
  page: 1,
  per_page: 100,
};

export const formatSelectValueToNumber = (
  value?: OptionValue | OptionValue[],
): number | number[] | undefined => {
  if (!value) return;
  if (Array.isArray(value)) {
    return value.map((item) => (typeof item === 'number' ? item : parseInt(item)));
  }
  return typeof value === 'number' ? value : parseInt(value);
};

export const getPeriodByName = (name: string): (string | undefined)[] => {
  switch (name) {
    case 'today':
      return [today.format(dateFormat), today.format(dateFormat)];
    case 'tomorrow':
      return [
        today.subtract(-1, 'day').format(dateFormat),
        today.subtract(-1, 'day').format(dateFormat),
      ];
    case 'week':
      return [today.startOf('week').format(dateFormat), today.endOf('week').format(dateFormat)];
    case 'month':
      return [today.startOf('month').format(dateFormat), today.endOf('month').format(dateFormat)];
    case 'quarter':
      return [
        today
          .set('month', (Math.ceil(today.month() / 3) - 1) * 3)
          .startOf('month')
          .format(dateFormat),
        today
          .set('month', (Math.ceil(today.month() / 3) - 1) * 3 + 2)
          .endOf('month')
          .format(dateFormat),
      ];
    case 'year':
      return [today.startOf('year').format(dateFormat), today.endOf('year').format(dateFormat)];

    case 'yesterday':
      return [
        today.subtract(1, 'day').format(dateFormat),
        today.subtract(1, 'day').format(dateFormat),
      ];
    case 'previous_week':
      return [
        today.subtract(1, 'week').startOf('week').format(dateFormat),
        today.subtract(1, 'week').endOf('week').format(dateFormat),
      ];
    case 'previous_month':
      return [
        today.subtract(1, 'month').startOf('week').format(dateFormat),
        today.subtract(1, 'month').endOf('week').format(dateFormat),
      ];
    case 'previous_year':
      return [
        today.subtract(1, 'year').startOf('week').format(dateFormat),
        today.subtract(1, 'year').endOf('week').format(dateFormat),
      ];

    default:
      return [undefined, undefined];
  }
};

export const convertToDate = (date: string | undefined): Date => {
  if (!date) {
    return new Date(today.toString());
  }
  return new Date(date);
};
